// extracted by mini-css-extract-plugin
export default {"item":"ListItem_item_dxVug","title":"ListItem_title_LnUcp","content":"ListItem_content_Wrubs","spinAround":"ListItem_spinAround_sw6DO"};